import React from 'react'
import { Box, Link } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { Link as RouterLink } from 'react-router-dom'

export default function RequirementAlert({
  children,
  link,
  linkTitle,
  severity = 'info',
}) {
  return (
    <Box mt={1} mb={1} textAlign="left">
      <Alert severity={severity}>
        {children}
        <Box mt={1}>
          <Link component={RouterLink} to={link}>
            {linkTitle}
          </Link>
        </Box>
      </Alert>
    </Box>
  )
}
